import { render, staticRenderFns } from "./Index-TaxInformation.vue?vue&type=template&id=3e5e2d78&scoped=true&"
import script from "./Index-TaxInformation.vue?vue&type=script&lang=js&"
export * from "./Index-TaxInformation.vue?vue&type=script&lang=js&"
import style0 from "./Index-TaxInformation.vue?vue&type=style&index=0&id=3e5e2d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e2d78",
  null
  
)

export default component.exports